import {ReactElement} from "react";
import Item from "../Model/Item";

interface Props {
    item: Item,
}

const ItemView: (props: Props) => ReactElement = (props: Props): ReactElement => {
    const { item } = props;

    return <div className="grid-item">{item.text}</div>;
}

export default ItemView;